import { Component, OnInit, Input, Inject } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NGXLogger } from "ngx-logger";
import { ISelectFeatureConnected, ISelectedFeatures, authOpt, authType } from "../../definitions";
import { UserSettingsService } from "../../services/user-settings-service";
import { WindowMessageService } from "../../services/window-message-service";
import { getExMessage } from "../../map/map-utils";



import Feature from 'ol/Feature';
import { Point } from "ol/geom";

    export interface ISpatiuVerde {
        proprietar: string;
        proprietate: string;
        modAdministrare: string;
        categorieDeFolosinta: string;
        reglementareUrbanistica: string;
        suprafataMasurataTerenExclusiv: number;
        suprafataMasurataTerenIndiviziune: number;
        totalTerenSpatiuVerde: number;
        observatii: string;
    }
   
    //
    export interface IConstructie {
        proprietar: string;
        proprietate: string;
        modAdministrare: string;
        nrCorpConstructie: string;
        codGrupaDestinatie: string;
        suprafataConstruitaLaSol: number;
        observatii: string;
    }

    export interface IArbore {
        nr: string;
        specia: string;
        inaltimeArbore: string;
        inaltimeTrunchi: string;
        numarIdentificare: string;
        ocrotit: string;
        suport: string;
        varsta: string;
        sanatate: string;
        intretinere: string;
        diametru?: string;
        amplasare?: string;
        categorie?: string;
        lucrari?: string;
    }

    export interface IVegetatie {
        nr: string;
        prescurtare: string;
        categorie: string;
        denumireStiintifica: string;
        denumirePopulara: string;
        numarExemplare: number;
        diametru: number;
        inaltime: number;
        varsta: number;
        observatii: string;
        ocrotit?: boolean;
        izolat?: boolean;
    }
    //
    export interface IVegetatieGroup {
        categorie: string;
        total: number;
        vegetatie: Array<IVegetatie>; 
    }
    //
    export interface IArboreRaportItem {
        //
        connectedFeatures: Array<ISelectFeatureConnected>;
        spatiuVerdeFeatures: Array<Feature>;
        //constructiiFeatures: Array<ISelectedFeatures>;
        vegetatieFeatures: Array<ISelectedFeatures>;
        //
        headInfo: IHeadInfo;
        mapImgUrl: string;
        adresa: string;
        long: any;
        lat: any;
        alt: any;
        //
        spatiiVerzi: Array<ISpatiuVerde>;
        //constructii: Array<IConstructie>;
        arbore: Array<IArbore>;
        vegetatie: Array<IVegetatie>;
        //vegetatieGroups: Array<IVegetatieGroup>;
        //vegetatieIzolata: Array<IVegetatie>;
        //vegetatieOcrotita: Array<IVegetatie>;
        //
        totalTerenSpatiiVerzi: number;
        totalSuprafataDinTerenSpatiuVerde: number;
        //
        echipareEdilitara: string;
        vegetatieExistenta: string;
        documenteEmise: string;
        printDate: string;
        numeMunicipiu: string;
        numeAprobat: string;
        dataAprobat: string;
        numeSursaUrl: string;
    }
    //
    export interface IHeadInfo {
        judet: string,
        localitatea: string,
        codSiruta: string,

        sectiunePlan: string,
        nrCadastral: string,
        nrCarteFunciara: string,

        codZonaValorica: string,
        codZonaProtejata: string,
        codPostal: string,

        adresa: string
    }
    //
    @Component({
        selector: 'fisa-arborelui',
        providers: [],
        templateUrl: './fisa-arborelui.component.html',
        styleUrls: ['./fisa-arborelui.component.css']
    })
    export class FisaArboreluiComponent implements OnInit{
        //
        selectedFeaturesConnectedOnLayers: Array<ISelectFeatureConnected>;
        //
        public mapImgUrl: string;
        //public svRaport: ISpatiuVerdeRaportItem = this.newReportItem();
        public svRaports: Array<IArboreRaportItem> = [];
        //
        //
        public denumiriColoaneHeader = {
            judetul: "Judetul",
            localitatea: "Localitatea",
            codsiruta: "Cod SIRUTA",
            sectiunePlan: "Sectiune plan",
            nrCadastral: "Nr. cadastral imobil",
            nrCarteFunciara: "Nr. carte funciara",
            codZonaValorica: "Cod zona valorica",
            codZonaProtejata: "Cod zona protejata",
            codPostal: "Cod postal"
        }
        //
        public numeInInfoHeaderSpatiuVerde = {
            judetul: "judetul",
            localitatea: "localitatea",
            codsiruta: "cod_SIRUTA",
            sectiunePlan: "sectiune_plan",
            nrCadastral: "nrcad_topo",
            nrCarteFunciara: "nr_carte_funciara",
            codZonaValorica: "cod_zona_valorica",
            codZonaProtejata: "cod_zona_protejata",
            codPostal: "cod_postal",
            adresa: "adresa"
        }
        //
        public denumiriColoaneSpatiuVerde = {
            proprietar: "Proprietar / Detinator spatiu verde",
            proprietate: "Proprietate",
            modAdministrare: "Mod administrare",
            categorieDeFolosinta: "Categorie de folosinta",
            reglementareUrbanistica: "Reglementare urbanistica",
            suprafataMasurataTerenExclusiv: "Suprafata masurata teren exclusiv",
            suprafataMasurataTerenIndiviziune: "Suprafata masurata teren indiviziune",
            totalTerenSpatiuVerde: "Total teren spatiu verde",
            observatii: "Observatii",
        }
        public numeInInfoFeatureSpatiuVerde = {
            proprietar: "proprietar",
            proprietate: "denumire",
            modAdministrare: "mod_de_adm",
            categorieDeFolosinta: "categorie",
            reglementareUrbanistica: "reglementare_urbanistica",
            suprafataMasurataTerenExclusiv: "suprafata",
            suprafataMasurataTerenIndiviziune: "teren_indiviziune",
            totalTerenSpatiuVerde: "suprafata",
            observatii: "observatii",
        }

        public  denumireColoaneArbore = {
            nr: "Nr.",
            specia: "Specia",
            inaltimeArbore: "Inaltime arbore",
            inaltimeTrunchi: "Inaltime trunchi",
            numarIdentificare: "NUI",
            ocrotit: "Ocrotit",
            suport: "Suport",
            varsta: "Varsta",
            sanatate: "Sanatate",
            intretinere: "Intretinere",
            diametru: "Diametru",
            amplasare: "Amplasare",
            categorie: "Categorie",
            lucrari: "Lucrari",
        }

        public  numeInInfoFeatureArbore = {
            specia: "specia",
            inaltimeArbore: "inaltime_arbore",
            inaltimeTrunchi: "inaltime_trunchi",
            numarIdentificare: "nrunic",
            ocrotit: "ocrotit",
            suport: "suport",
            varsta: "varsta",
            sanatate: "sanatate",
            intretinere: "intretinere",
            diametru: "diametru",
            amplasare: "amplasare",
            categorie: "categorie",
            lucrari: "lucrari",
        }

        public denumiriColoaneVegetatie = {
            nr: "Nr. crt.",
            prescurtare: "Prescurtare",
            categorie: "Categorie",
            denumireStiintifica: "Denumire stiintifica",
            denumirePopulara: "Denumire populara",
            numarExemplare: "Numar exemplare",
            diametru: "DIAM. cm",
            inaltime: "INAL. m",
            varsta: "VARSTA ani",
            observatii: "Obs.",
        }
        public numeInInfoFeatureVegetatie = {
            nr: "nrunic",
            prescurtare: "prescurtare",
            categorie: "categorie",
            denumireStiintifica: "denumire_stintifiica",
            denumirePopulara:"specie",
            numarExemplare: "numar",
            diametru: "coronament",
            inaltime: "inaltime",
            varsta: "varsta",
            observatii: "observatii",
            ocrotit: "ocrotit",
            izolat: "izolat"
        }
        //
        @Input() data: any;
        //
        constructor(
            @Inject(NgbActiveModal) private activeModal: NgbActiveModal,
            @Inject(NGXLogger) private $log: NGXLogger,
            @Inject(UserSettingsService) private userSettingsService: UserSettingsService,
            @Inject(WindowMessageService) private windowMessageService: WindowMessageService,
            @Inject(DomSanitizer) private sanitizer: DomSanitizer,
        ) {
            //test only
        }
        public ngOnInit(): void {
            if (this.data.mapImgUrl && this.data["selectedFeaturesConnectedOnLayers"]) {
                this.selectedFeaturesConnectedOnLayers = this.data["selectedFeaturesConnectedOnLayers"];
                this.mapImgUrl = this.sanitizer.bypassSecurityTrustUrl(this.data.mapImgUrl) as any;
                //this.processTablesDataCombined();
                this.processTablesDataSeparated();
            }
            else {
                this.$log.warn("straturile cu date nu exista");
                this.activeModal.close(false);
            }
        }

        private newReportItem(): IArboreRaportItem {
            let printdate = new Date().getDate().toString() + "." + (new Date().getMonth() + 1).toString() + "." + new Date().getFullYear().toString();
            
            return {
                connectedFeatures: [],
                spatiuVerdeFeatures: [],
                //constructiiFeatures: [],
                vegetatieFeatures: [],
                //vegetatieIzolata: [],
                //vegetatieOcrotita: [],
                //
                headInfo: {
                    judet: "",
                    localitatea: "",
                    codSiruta: "",
                    //
                    sectiunePlan: "",
                    nrCadastral: "",
                    nrCarteFunciara: "",
                    //
                    codZonaValorica: "",
                    codZonaProtejata: "",
                    codPostal: "",
                    adresa: ""
                },
                mapImgUrl: "",
                adresa: "",
                long: "111",
                lat: "222",
                alt: "000",
                spatiiVerzi: [],
                //constructii: [],
                arbore: [],
                vegetatie: [],
                //vegetatieGroups: [],
                totalTerenSpatiiVerzi: 0,
                totalSuprafataDinTerenSpatiuVerde: 0,
                //
                echipareEdilitara: "",
                vegetatieExistenta: "",
                documenteEmise: "nu e cazul.",
                printDate: printdate,
                dataAprobat: "-",
                numeAprobat: "-",
                numeMunicipiu: "-",
                numeSursaUrl: "https://geoportal.e-bistrita.ro",
            }
        }
        //
        private processTablesDataCombined() {
            this.svRaports = [];
            let tmpReport = this.newReportItem();
            let message = "";
            
            //
            this.selectedFeaturesConnectedOnLayers.forEach((selItem) => {
                try {
                    tmpReport.spatiuVerdeFeatures.push(selItem.feature);
                    // selItem.connectedConstructii.forEach((conItem) => {
                    //     tmpReport.constructiiFeatures.push(conItem);
                    // });
                    selItem.connectedVegetatie.forEach((conItem) => {
                        tmpReport.vegetatieFeatures.push(conItem);
                    });
                } catch (e) {
                    message += " -- " + e.message || '';
                }
            });
            //
            this.processReportItemTables(tmpReport);
            this.svRaports.push(tmpReport);
            //
            if (message.length > 0) {
                this.$log.error("erroare parsare: ", getExMessage(message));
            }

        }

        private processTablesDataSeparated() {
            this.svRaports = [];
            let message = "";
            //
            
            this.selectedFeaturesConnectedOnLayers.forEach((selItem) => {
                try {
                    let tmpRitem = this.newReportItem();
                    let numeMun =  this.userSettingsService.isAuthForOptionFullInfo(authOpt.report_arbore_info_municipiu, selItem.layer["appLayer"]["name"], authType.layer)
                    if (numeMun && numeMun.descriere){
                        tmpRitem.numeMunicipiu = numeMun.descriere;
                    }
                    let numeApr =  this.userSettingsService.isAuthForOptionFullInfo(authOpt.report_arbore_info_aprobat_nume, selItem.layer["appLayer"]["name"], authType.layer)
                    if (numeApr && numeApr.descriere){
                        tmpRitem.numeAprobat = numeApr.descriere;
                    }
                    let dataApr =  this.userSettingsService.isAuthForOptionFullInfo(authOpt.report_arbore_info_aprobat_data, selItem.layer["appLayer"]["name"], authType.layer)
                    if (dataApr && dataApr.descriere){
                        tmpRitem.dataAprobat = dataApr.descriere;
                    }
                    let sursaUrl =  this.userSettingsService.isAuthForOptionFullInfo(authOpt.report_arbore_info_nume_sursa_url, selItem.layer["appLayer"]["name"], authType.layer)
                    if (sursaUrl && sursaUrl.descriere){
                        tmpRitem.numeSursaUrl = sursaUrl.descriere;
                    }

                    tmpRitem.connectedFeatures.push(selItem);
                    if (selItem.connectedSpatiiVerzi && selItem.connectedSpatiiVerzi.length > 0
                        && selItem.connectedSpatiiVerzi[0].features && selItem.connectedSpatiiVerzi[0].features.getLength() > 0){
                            tmpRitem.spatiuVerdeFeatures.push(selItem.connectedSpatiiVerzi[0].features.getArray()[0]);
                        }
                    if (selItem.feature){
                        tmpRitem.vegetatieFeatures.push({features: [selItem.feature] as any, layer: selItem.layer})
                    }
                   
                    //
                    this.processReportItemTables(tmpRitem);
                    //
                    this.svRaports.push(tmpRitem);
                    //testonly
                    //this.svRaports.push(tmpRitem);
                } catch (e) {
                    message += " -- " + e.message || '';
                }
            });
            //
            if (message.length > 0) {
                this.$log.error("erroare parsare: ", getExMessage(message));
            }
        }

        private processReportItemTables(raportItem: IArboreRaportItem) {
            let message = "";
            //
            raportItem.spatiuVerdeFeatures.forEach((svitem) => {
                try {
                    let tmpItem = this.processFeatureSpatiuVerde(svitem);
                    raportItem.spatiiVerzi.push(tmpItem);
                    raportItem.totalTerenSpatiiVerzi += tmpItem.totalTerenSpatiuVerde;
                    //
                    if (raportItem.spatiiVerzi.length === 1) {
                        raportItem.headInfo = this.processHeaderSpatiuVerde(svitem);
                        raportItem.adresa = raportItem.headInfo.adresa;
                        let arbFeat = raportItem.vegetatieFeatures[0].features as Array<any>[0]
                        raportItem.long = (arbFeat[0].getGeometry() as Point).getCoordinates()[0];
                        raportItem.lat = (arbFeat[0].getGeometry() as Point).getCoordinates()[1];
                    } else {
                        //cumuleaza info
                        this.cumulateHeaderSpatiuVerde(svitem, raportItem.headInfo);
                    }
                     //
                } catch (e) {
                    message += " -- " + e.message || '';
                }
            });

            raportItem.vegetatieFeatures.forEach((clfitem) => {
                clfitem.features.forEach((citem, index) => {
                    try {
                        let tmpItem = this.processFeatureArbore(citem);
                        tmpItem.nr = (index + 1).toString();
                        raportItem.arbore.push(tmpItem);
                        //
                        // if (tmpItem.izolat) {
                        //     raportItem.vegetatieIzolata.push(tmpItem);
                        // }
                        // if (tmpItem.ocrotit) {
                        //     raportItem.vegetatieOcrotita.push(tmpItem);
                        // }
                    } catch (e) {
                        message += " -- " + e.message || '';
                    }
                })
            });
            //create groups
            //this.processVegetatieGroups(raportItem);
            //
            if (message.length > 0) {
                this.$log.error("erroare parsare: ", getExMessage(message));
            }
        }

        
        private processHeaderSpatiuVerde(feature: Feature): IHeadInfo {
            var tmpsv: IHeadInfo = null;
            try {
                tmpsv = {
                    judet: feature.get(this.numeInInfoHeaderSpatiuVerde.judetul) || '',
                    localitatea: feature.get(this.numeInInfoHeaderSpatiuVerde.localitatea) || '',
                    codSiruta: feature.get(this.numeInInfoHeaderSpatiuVerde.codsiruta) || '',
                    sectiunePlan: feature.get(this.numeInInfoHeaderSpatiuVerde.sectiunePlan) || '',
                    nrCadastral: feature.get(this.numeInInfoHeaderSpatiuVerde.nrCadastral) || '',
                    nrCarteFunciara: feature.get(this.numeInInfoHeaderSpatiuVerde.nrCarteFunciara) || "",
                    codPostal: feature.get(this.numeInInfoHeaderSpatiuVerde.codPostal) || "",
                    codZonaValorica: feature.get(this.numeInInfoHeaderSpatiuVerde.codZonaValorica) || "",
                    codZonaProtejata: feature.get(this.numeInInfoHeaderSpatiuVerde.codZonaProtejata) || '',
                    adresa: feature.get(this.numeInInfoHeaderSpatiuVerde.adresa) || ''
                }
            } catch (e) {
                throw new Error("eroare parsare date " + e.message || '')
            }
            return tmpsv;
        }
        //
        private cumulateHeaderSpatiuVerde(feature: Feature, headerInfo: IHeadInfo) {
            let tmp = this.processHeaderSpatiuVerde(feature);
            headerInfo.judet = headerInfo.judet + tmp.judet;
            headerInfo.localitatea = headerInfo.localitatea + tmp.localitatea;
            headerInfo.codSiruta = headerInfo.codSiruta + tmp.codSiruta;
            headerInfo.sectiunePlan = headerInfo.sectiunePlan + tmp.sectiunePlan;
            headerInfo.nrCadastral = headerInfo.nrCadastral + tmp.nrCadastral;
            headerInfo.nrCarteFunciara = headerInfo.nrCarteFunciara + tmp.nrCarteFunciara;
            headerInfo.codPostal = headerInfo.codPostal + tmp.codPostal;
            headerInfo.codZonaValorica = headerInfo.codZonaValorica + tmp.codZonaValorica;
            headerInfo.codZonaProtejata = headerInfo.codZonaProtejata + tmp.codZonaProtejata;
        }

        private processFeatureSpatiuVerde(feature: Feature): ISpatiuVerde {
            var tmpsv: ISpatiuVerde = null;
            try {
                tmpsv = {
                    proprietar: feature.get(this.numeInInfoFeatureSpatiuVerde.proprietar) || '',
                    proprietate: feature.get(this.numeInInfoFeatureSpatiuVerde.proprietate) || '',
                    modAdministrare: feature.get(this.numeInInfoFeatureSpatiuVerde.modAdministrare) || '',
                    categorieDeFolosinta: feature.get(this.numeInInfoFeatureSpatiuVerde.categorieDeFolosinta) || '',
                    reglementareUrbanistica: feature.get(this.numeInInfoFeatureSpatiuVerde.reglementareUrbanistica) || '',
                    suprafataMasurataTerenExclusiv:  Number(feature.get(this.numeInInfoFeatureSpatiuVerde.suprafataMasurataTerenExclusiv)) || 0,
                    suprafataMasurataTerenIndiviziune: Number(feature.get(this.numeInInfoFeatureSpatiuVerde.suprafataMasurataTerenIndiviziune)) || 0,
                    totalTerenSpatiuVerde: (Number(feature.get(this.numeInInfoFeatureSpatiuVerde.suprafataMasurataTerenExclusiv)) || 0) +
                                            (Number(feature.get(this.numeInInfoFeatureSpatiuVerde.suprafataMasurataTerenIndiviziune)) || 0),
                    //totalTerenSpatiuVerde: Number(feature.get(this.numeInInfoFeatureSpatiuVerde.totalTerenSpatiuVerde)) || 0,
                    observatii: feature.get(this.numeInInfoFeatureSpatiuVerde.observatii) || '',
                }
            } catch (e) {
                throw new Error("eroare parsare date " + e.message || '')
            }
            return tmpsv;
        }

        private processFeatureArbore(feature: Feature) {
            var tmpCon: IArbore = null;
            try {
                tmpCon = {

                    nr: feature.get(this.numeInInfoFeatureVegetatie.nr) || 0,
                    specia: feature.get(this.numeInInfoFeatureArbore.specia) || "",
                    inaltimeArbore: feature.get(this.numeInInfoFeatureArbore.inaltimeArbore) || "",
                    inaltimeTrunchi: feature.get(this.numeInInfoFeatureArbore.inaltimeTrunchi) || "",
                    numarIdentificare: feature.get(this.numeInInfoFeatureArbore.numarIdentificare) || "",
                    ocrotit: feature.get(this.numeInInfoFeatureArbore.ocrotit) || "",
                    suport: feature.get(this.numeInInfoFeatureArbore.suport) || "",
                    varsta: feature.get(this.numeInInfoFeatureArbore.varsta) || "",
                    sanatate: feature.get(this.numeInInfoFeatureArbore.sanatate) || "",
                    intretinere: feature.get(this.numeInInfoFeatureArbore.intretinere) || "",
                    diametru: feature.get(this.numeInInfoFeatureArbore.diametru) || "",
                    amplasare: feature.get(this.numeInInfoFeatureArbore.amplasare) || "",
                    categorie: feature.get(this.numeInInfoFeatureArbore.categorie) || "",
                    lucrari: feature.get(this.numeInInfoFeatureArbore.lucrari) || ""
                }
            } catch (e) {
                throw new Error("eroare parsare date " + e.message || '')
            }
            return tmpCon;
        }

       

        private processFeatureVegetatie(feature: Feature) {
            var tmpCon: IVegetatie = null;
            try {
                tmpCon = {

                    nr: feature.get(this.numeInInfoFeatureVegetatie.nr) || 0,
                    prescurtare: feature.get(this.numeInInfoFeatureVegetatie.prescurtare) || "",
                    categorie: feature.get(this.numeInInfoFeatureVegetatie.categorie) || "",
                    denumireStiintifica: feature.get(this.numeInInfoFeatureVegetatie.denumireStiintifica) || "",
                    denumirePopulara: feature.get(this.numeInInfoFeatureVegetatie.denumirePopulara) || "",
                    numarExemplare: feature.get(this.numeInInfoFeatureVegetatie.numarExemplare) || 1,
                    diametru: feature.get(this.numeInInfoFeatureVegetatie.diametru) || '-',
                    inaltime: feature.get(this.numeInInfoFeatureVegetatie.inaltime) || '-',
                    varsta: feature.get(this.numeInInfoFeatureVegetatie.varsta) || '-',
                    observatii: feature.get(this.numeInInfoFeatureVegetatie.nr) || "",
                    ocrotit: feature.get(this.numeInInfoFeatureVegetatie.ocrotit),
                    izolat: feature.get(this.numeInInfoFeatureVegetatie.izolat)
                }
            } catch (e) {
                throw new Error("eroare parsare date " + e.message || '')
            }
            return tmpCon;
        }

        // private processVegetatieGroups(raportItem : IArboreRaportItem) {
        //     raportItem.vegetatieGroups = [];
        //     let groups: Array<string> = raportItem.vegetatie.map(x => x.categorie);
        //     //
        //     groups = groups.filter((value, index, self) => {
        //         return self.indexOf(value) === index;
        //     });
        //     //
        //     groups.forEach((gritem) => {
        //         let tmpgroup = { categorie: gritem,total: 0, vegetatie: [] };
        //         tmpgroup.vegetatie = raportItem.vegetatie.filter((item) => item.categorie === gritem) || [];
        //         tmpgroup.vegetatie.forEach((item: IVegetatie, index) => {
        //             //
        //             item.nr = (index + 1).toString();
        //             let countVegetatie = Number(item.numarExemplare);
        //             if (!isNaN(countVegetatie)) {
        //                 tmpgroup.total += countVegetatie;
        //             }
        //         })
        //         raportItem.vegetatieGroups.push(tmpgroup);
        //     });
        // }

        public cancel(): void {
            this.activeModal.close(false);
        }

        private testData() {
            let tmpRaport: IArboreRaportItem = this.newReportItem();
            tmpRaport.headInfo = {
                judet: "aaa",
                localitatea: "bbb",
                codSiruta: "ccc",

                sectiunePlan: "ddd",
                nrCadastral: "fff",
                nrCarteFunciara: "ggg",

                codZonaValorica: "hhh",
                codZonaProtejata: "jjj",
                codPostal: "kkk",
                adresa: "addre"

            }
            tmpRaport.totalTerenSpatiiVerzi = 40;
            tmpRaport.totalSuprafataDinTerenSpatiuVerde = 10;
            tmpRaport.spatiiVerzi = [
                {
                    proprietar: "a",
                    proprietate: "s",
                    modAdministrare: "d",
                    categorieDeFolosinta: "f",
                    reglementareUrbanistica: "g",
                    suprafataMasurataTerenExclusiv: 2,
                    suprafataMasurataTerenIndiviziune: 2,
                    totalTerenSpatiuVerde: 4,
                    observatii: "l",
                },
                {
                    proprietar: "a1",
                    proprietate: "s1",
                    modAdministrare: "d1",
                    categorieDeFolosinta: "f1",
                    reglementareUrbanistica: "g1",
                    suprafataMasurataTerenExclusiv: 3,
                    suprafataMasurataTerenIndiviziune: 3,
                    totalTerenSpatiuVerde: 6,
                    observatii: "l1",
                }
            ];
            

        }
    }
